import { ConfigProvider } from "antd";
import koKr from "antd/es/locale/ko_KR";
import moment from "moment";
import "moment/locale/ko";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import ModalRenderer from "./components/molecures/Modals/ModalRenderer";
import LayoutForm from "./components/organisms/Layout";
import SpecialMateLayout from "./components/organisms/SpecialRepairShopLayout";
import NotFound from "./pages/NotFound";
import {
  LinkArray,
  autoOasisArray,
  notAuthArray,
  speedMateArray,
} from "./routes";
import AuthRoute from "./routes/AuthRoute";
import NotAuthRoute from "./routes/NotAuthRoute";
import SpecialRoute from "./routes/SpecialCodeRoute";
import withQueryClient from "./shared/utils/hoc/withQueryClient";
import color from "./theme/color";

import "./style/App.less";
import "./style/antd.custom.css";

moment.locale("ko", {
  week: {
    dow: 0,
    doy: 4,
  },
});

function App() {
  return (
    <>
      <ConfigProvider
        locale={koKr}
        form={{
          validateMessages: {
            required: "필수 입력 값입니다.",
          },
        }}
      >
        <ThemeProvider theme={{ color }}>
          <Router>
            <Routes>
              {speedMateArray.map(({ path, component }, index) => (
                <Route
                  key={`${path}speedMate`}
                  path={path}
                  element={<SpecialRoute />}
                  errorElement={<NotFound type="EMPTY" />}
                >
                  <Route
                    key={`speedMate${index.toString()}`}
                    path={path}
                    element={<SpecialMateLayout>{component}</SpecialMateLayout>}
                    errorElement={<NotFound type="EMPTY" />}
                  />
                </Route>
              ))}
              {autoOasisArray.map(({ path, component }, index) => (
                <Route
                  key={`${path}autooasis`}
                  path={path}
                  element={<SpecialRoute />}
                  errorElement={<NotFound type="EMPTY" />}
                >
                  <Route
                    key={`autooasis${index.toString()}`}
                    path={path}
                    element={<SpecialMateLayout>{component}</SpecialMateLayout>}
                    errorElement={<NotFound type="EMPTY" />}
                  />
                </Route>
              ))}
              {notAuthArray.map(({ path, component }, index) => {
                return (
                  <Route
                    key={`${path}not-auth`}
                    path={path}
                    element={<NotAuthRoute />}
                    errorElement={<NotFound />}
                  >
                    <Route
                      key={index.toString()}
                      path={path}
                      element={component}
                      errorElement={<NotFound />}
                    />
                  </Route>
                );
              })}

              {LinkArray.map(({ path, component }, index) => (
                <Route
                  key={`${path}auth`}
                  path={path}
                  element={<AuthRoute />}
                  errorElement={<NotFound type="EMPTY" />}
                >
                  <Route
                    key={index.toString()}
                    path={path}
                    element={<LayoutForm>{component}</LayoutForm>}
                    errorElement={<NotFound type="EMPTY" />}
                  />
                </Route>
              ))}
              <Route key="/" path="*" element={<NotFound />} />
            </Routes>

            <ModalRenderer />
          </Router>
        </ThemeProvider>
      </ConfigProvider>
    </>
  );
}

export default withQueryClient(App);
